import { css, html } from 'react-strict-dom';
import { spacing } from 'src/constants/spacing.css';

import { Style } from '../constants';

type Props = {
  size?: number; // optional multiplier
  fill?: boolean;
};

export default function Spacer({ size = 1, fill = false }: Props) {
  return <html.div style={[styles.size(size), fill && Style.fill]} />;
}

const styles = css.create({
  size: (size: number) => ({
    width: `calc(${spacing.unit} * ${size})`,
    height: `calc(${spacing.unit} * ${size})`,
  }),
});
